const STORAGE_PREFIX = 'activity-started';

function getStorageKey(slug, entityId) {
  return `${STORAGE_PREFIX}:${slug}:${entityId}`;
}

export function getActivityStarted(slug, entityId) {
  if (!slug || !entityId || typeof window === 'undefined') {
    return false;
  }

  try {
    return window.localStorage.getItem(getStorageKey(slug, entityId)) === '1';
  } catch {
    return false;
  }
}

export function setActivityStarted(slug, entityId) {
  if (!slug || !entityId || typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(getStorageKey(slug, entityId), '1');
  } catch {
    // Ignore storage failures (private mode, quota, etc.)
  }
}
